import { z } from 'zod';
import { getMutationSchema } from '../../../../ui/util/getMutationSchema';
import { ResourceType } from '../../../enumerations/ResourceType';
import { useMultiParentlessResourceAdapterActions } from '../../../resource-base/adapters/useMultiParentlessResourceAdapterActions';
import {
    defaultNamedArtifactResource,
    NamedArtifactResourceSchema,
} from '../../../resource-base/artifactResourceTypes';

export enum ProjectPropertyValidation {
    NAME = 'NAME',
    DESCRIPTION = 'DESCRIPTION',
    VERSION_INFO = 'VERSION_INFO',
    IS_VISIBLE = 'IS_VISIBLE',
}

export const ProjectResourceSchema = NamedArtifactResourceSchema.extend({
    resourceType: z.literal(ResourceType.PROJECT).default(ResourceType.PROJECT),
    description: z.string(),
    isVisible: z.boolean(),
});

export const ProjectMutationResourceSchema = getMutationSchema(ProjectResourceSchema);

export type ProjectResource = z.infer<typeof ProjectResourceSchema>;

export const defaultProjectResource: ProjectResource = {
    ...defaultNamedArtifactResource,
    resourceType: ResourceType.PROJECT,
    description: '',
    isVisible: false,
};

export function useProjectActions() {
    const actions = useMultiParentlessResourceAdapterActions('project', ResourceType.PROJECT, ProjectResourceSchema);

    return {
        ...actions,
    };
}
